import DropzoneWrapper from './presentation';

export default DropzoneWrapper;
